import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { Button } from './ui/Button';
import { Card } from './ui/Card';

interface GameErrorBoundaryProps {
  children: React.ReactNode;
  onGameReset?: () => void;
}

export const GameErrorBoundary: React.FC<GameErrorBoundaryProps> = ({ 
  children, 
  onGameReset 
}) => {
  const handleGameError = (error: Error) => {
    // Log game-specific error details
    console.error('Game error occurred:', {
      error: error.message,
      stack: error.stack,
      timestamp: new Date().toISOString(),
      gameState: localStorage.getItem('wallstreetle-game-state')
    });
  };

  const GameErrorFallback = (
    <Card className="p-6 text-center border-yellow-200 dark:border-yellow-800 bg-yellow-50 dark:bg-yellow-900/20">
      <div className="mb-4">
        <div className="w-12 h-12 mx-auto mb-4 text-yellow-600 dark:text-yellow-400">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-yellow-800 dark:text-yellow-200 mb-2">
          Game Error
        </h3>
        <p className="text-yellow-700 dark:text-yellow-300 text-sm mb-4">
          The game encountered an error and needs to be reset. Your progress may be lost.
        </p>
        <div className="flex gap-2 justify-center">
          {onGameReset && (
            <Button onClick={onGameReset} variant="outline" size="sm">
              Reset Game
            </Button>
          )}
          <Button onClick={() => window.location.reload()} size="sm">
            Reload Page
          </Button>
        </div>
      </div>
    </Card>
  );

  return (
    <ErrorBoundary
      fallback={GameErrorFallback}
      onError={handleGameError}
      isolate={true}
    >
      {children}
    </ErrorBoundary>
  );
};